const _auto = "auto"
const _min = "min-content"
const _max = "max-content"
const _fr = "minmax(0, 1fr)"
const config = { "auto": _auto, "min": _min, "max": _max, "fr": _fr,  }
export { config as default, _auto, _min, _max, _fr }